import { useNavigate, useParams } from 'react-router';
import { InvitationEntryContent } from 'components/invitation/InvitationEntryContent';
import './InvitationEntry.css';

export const InvitationEntry = () => {
    const navigate = useNavigate();
    const { inviteCode } = useParams();

    // Mock invitation data
    const invitation = {
        meetingName: '맛집 탐방',
        hostName: '김위즈',
        date: '2024년 7월 15일 (월)',
        time: '오후 6:00',
        location: '강남역 1번 출구',
        participants: 4,
        description: '강남역 근처 맛집을 탐방하며 저녁을 함께 즐겨요!'
    };

    const handleJoin = () => {
        navigate(`/invitation/info/${inviteCode}`);
    };

    const handleDecline = () => {
        navigate('/home');
    };

    return (
        <div className="invitation-entry-wrapper">
            <InvitationEntryContent
                invitation={invitation}
                onJoin={handleJoin}
                onDecline={handleDecline}
            />
        </div>
    );
};
